//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debug from 'debug'
import { getModel } from '@/scripts/form/models/Register'

import InputWrapper from '@/components/form/InputWrapper'

import {
  required,
  sameAs,
  email,
  minLength,
  exactLength,
} from '@/scripts/form/Validations'
import {
  validDate,
  minAgeDate,
  maxAgeDate,
} from '@/scripts/form/DayValidations'
import { mapState } from 'vuex'

import ReCaptchaMixin from '@/mixins/ReCaptcha'

const log = debug('component:form:RegistrationForm')

export default {
  name: 'RegisterForm',
  components: { InputWrapper },
  mixins: [ReCaptchaMixin],
  data() {
    return {
      errorMessage: null,
      serverError: null,
      errorList: {},
      loading: false,
      success: false,
      form: getModel(),
      valid: null,
      action: 'register',
    }
  },
  computed: {
    ...mapState('consumer', ['register']),
    hasFieldErrors() {
      return Object.keys(this.errorList).length
    },
  },
  methods: {
    onEnter(e) {
      e.target.click()
    },
    async validateForm() {
      let valid = true
      this.errorMessage = null
      this.errorList = {}

      // Email
      if (required(this.form.email.value) === false) {
        this.form.email.valid = false
        valid = false
        this.errorList.email = 'Email is required'
      } else if (email(this.form.email.value) === false) {
        this.form.email.valid = false
        valid = false
        this.errorList.email = 'Email is invalid'
        this.form.email.valid = true
      } else {
        this.form.email.valid = true
      }

      // Confirm Email
      if (required(this.form.confirmEmail.value) === false) {
        this.form.confirmEmail.valid = false
        this.errorList.confirmEmail = 'Confirm Email is required'
        valid = false
      } else if (
        sameAs(
          this.form.confirmEmail.value.toLowerCase(),
          this.form.email.value.toLowerCase()
        ) === false
      ) {
        this.form.confirmEmail.valid = false
        valid = false
        this.errorList.confirmEmail = 'Email addresses must match'
      } else {
        this.form.confirmEmail.valid = true
      }

      // First name
      if (required(this.form.firstName.value) === false) {
        this.form.firstName.valid = false
        valid = false
        this.errorList.firstName = 'First name is required'
      } else {
        this.form.firstName.valid = true
      }

      // Last name
      if (required(this.form.lastName.value) === false) {
        this.form.lastName.valid = false
        valid = false
        this.errorList.lastName = 'Last name is required'
      } else {
        this.form.lastName.valid = true
      }

      // Zip
      if (required(this.form.zip.value) === false) {
        this.form.zip.valid = false
        valid = false
        this.errorList.zip = 'Zipcode is required'
      } else if (exactLength(this.form.zip.value, 5) === false) {
        this.form.state.valid = false
        valid = false
        this.errorList.zip = 'Zipcode is invalid'
      } else {
        this.form.zip.valid = true
      }

      // Password
      if (required(this.form.password.value) === false) {
        this.form.password.valid = false
        valid = false
        this.errorList.password = 'password is required'
      } else if (minLength(this.form.password.value, 8) === false) {
        this.form.password.valid = false
        valid = false
        this.errorList.password = 'password must be at least 8 characters'
      } else {
        this.form.password.valid = true
      }

      // Confirm Password
      if (required(this.form.confirmPassword.value) === false) {
        this.form.confirmPassword.valid = false
        this.errorList.confirmPassword = 'Passwords must match'
        valid = false
      } else if (
        sameAs(this.form.confirmPassword.value, this.form.password.value) ===
        false
      ) {
        this.form.confirmPassword.valid = false
        valid = false
        this.errorList.confirmPassword = 'Passwords must match'
      } else {
        this.form.confirmPassword.valid = true
      }

      // Birthdate
      if (required(this.form.birthday.value) === false) {
        this.form.birthday.valid = false
        valid = false
        this.errorList.birthday = 'Birthdate is required'
      } else if (validDate(this.form.birthday.value) === false) {
        this.form.birthday.valid = false
        valid = false
        this.errorList.birthday = 'Birthdate is invalid'
      } else if (minAgeDate(this.form.birthday.value, 18) === false) {
        this.form.birthday.valid = false
        valid = false
        this.errorList.birthday = 'Birthdate is invalid'
      } else if (maxAgeDate(this.form.birthday.value, 116) === false) {
        this.form.birthday.valid = false
        valid = false
        this.errorList.birthday = 'Birthdate is invalid'
      } else {
        this.form.birthday.valid = true
      }

      // Terms
      if (this.form.terms.value === false) {
        this.form.terms.valid = false
        valid = false
      } else {
        this.form.terms.valid = true
      }

      // ReCaptcha
      if (this.useCaptcha === true && valid) {
        await this.recaptcha().catch((err) => {
          log(err)
        })
        if (this.isCaptchaValid !== true) {
          valid = false
          this.errorMessage =
            'Unable to process request. Please try again later.'
        } else {
          log('ReCaptcha token: ', this.captchaResponse)
        }
      }

      return valid
    },
    getPayload() {
      const payload = {}
      if (this.form.facebook_token.value) {
        payload.facebookToken = this.form.facebook_token.value
      }

      payload.firstName = this.form.firstName.value
      payload.lastName = this.form.lastName.value
      payload.email = this.form.email.value
      payload.zipcode = this.form.zip.value
      payload.rules = this.form.terms.value
      payload.optInEmail = this.form.emailOptin.value
      // payload.optInSms = this.form.smsOptin.value

      const birthday = this.form.birthday.value.split('/')

      payload.birthdate = `${birthday[2]}-${birthday[0]}-${birthday[1]}`

      payload.password = this.form.password.value
      payload.passwordConfirm = this.form.confirmPassword.value

      // handle captcha
      if (this.useCaptcha) {
        payload.captchaResponse = this.captchaResponse
      } else {
        payload.captchaResponse = 'testString'
      }

      return payload
    },
    async submitForm(e) {
      e.preventDefault()
      if (this.loading) {
        return
      }
      this.loading = true

      const formIsValid = await this.validateForm()

      if (formIsValid) {
        const response = await this.$store.dispatch(
          'consumer/register',
          this.getPayload()
        )
        if (response.success) {
          this.$router.push('/account')
        } else {
          this.errorMessage = response.error
            .toLowerCase()
            .includes('document already exists')
            ? 'Error: An account with this email address already exists'
            : response.error
        }
      }
      this.loading = false
    },
    resetForm() {
      this.errorMessage = null
      this.form = getModel()
      this.success = false
      this.errorList = {}
    },
  },
}
